"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var DocExpireSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M8,14 L8,15 L5.99124403,15 C5.43895928,15 4.99124403,14.5522847 4.99124403,14 L4.99124403,5 C4.99124403,4.44771525 5.43895928,4 5.99124403,4 L10.7,4 L13.0034583,6.3 L13,8 L12,8 L12.0034583,6.7 L10.3,5 L5.99124403,5 L5.99124403,14 L8,14 Z M10.1456873,14.1361059 L11.767767,12.4748737 L10.1502443,10.860243 C9.95498233,10.6653301 9.95469933,10.3490309 10.1496122,10.1537689 C10.3452414,9.95813939 10.6618631,9.95799774 10.8573511,10.1531362 L12.4748737,11.767767 L14.1363814,10.1488347 C14.3349084,9.9553948 14.6520466,9.95745271 14.8480466,10.1534527 C15.040791,10.3461971 15.040791,10.6586974 14.8480466,10.8514418 L14.8434882,10.8559415 L13.1819805,12.4748737 L14.8479903,14.1403528 C15.0432524,14.3355528 15.0433029,14.6520848 14.8481029,14.847347 C14.6527754,15.0426746 14.3361859,15.0426998 14.1408835,14.8474596 L12.4748737,13.1819805 L10.8527941,14.8432127 C10.6621609,15.0384473 10.3493533,15.0421774 10.1541187,14.8515442 L10.1499281,14.8474033 C9.95398773,14.6514629 9.95209717,14.3343688 10.1456873,14.1361059 Z" })));
};
DocExpireSmall.displayName = 'DocExpireSmall';
exports.default = DocExpireSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=DocExpireSmall.js.map